import { Theme } from '@mui/material/styles';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function Autocomplete(theme: Theme): unknown {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
          },
        },
      },
    },
  };
}
